import React, { FC, HTMLAttributes, KeyboardEvent, useCallback } from "react";

interface Props extends HTMLAttributes<HTMLInputElement> {
  max?: number;
  value?: number;
  onChangeText?: (value: number) => void;
  isInvalid?: boolean;
}

const VALID_FIRST = /^[1-9]{1}$/;
const VALID_NEXT = /^[0-9]{1}$/;
const DELETE_KEY_CODE = 8;

const CurrencyInput: FC<Props> = ({
  max = Number.MAX_SAFE_INTEGER,
  onChangeText,
  isInvalid,
  ...props
}) => {
  const value = Math.round(props?.value || 0);
  const valueAbsTrunc = Math.trunc(Math.abs(value));

  React.useEffect(() => {
    if (
      value !== valueAbsTrunc ||
      !Number.isFinite(value) ||
      Number.isNaN(value)
    ) {
      throw new Error(`[CurrencyInput]: Invalid value property {${value}}`);
    }
  }, [value, valueAbsTrunc]);

  const handleKeyDown = useCallback(
    (event: KeyboardEvent<HTMLDivElement>): void => {
      event.preventDefault();

      let nextValue: number;
      let { key, keyCode } = event;

      if (
        (value === 0 && !VALID_FIRST.test(key)) ||
        (value !== 0 && !VALID_NEXT.test(key) && keyCode !== DELETE_KEY_CODE)
      ) {
        return;
      }

      const valueString = value.toString();

      if (keyCode !== DELETE_KEY_CODE) {
        const nextValueString: string =
          value === 0 ? key : `${valueString}${key}`;
        nextValue = Number.parseInt(nextValueString, 10);
      } else {
        const nextValueString = valueString.slice(0, -1);
        nextValue =
          nextValueString === "" ? 0 : Number.parseInt(nextValueString, 10);
      }

      if (nextValue > max) return;
      onChangeText?.(nextValue);
    },
    [max, onChangeText, value]
  );

  const handleChange = useCallback(() => {
    // DUMMY TO AVOID REACT WARNING
  }, []);

  const valueDisplay = (value / 100).toLocaleString("pt-BR", {

  });

  return (
    <input
      {...props}
      className={`form-control ${!!isInvalid ? "is-invalid" : ""}`}
      inputMode="numeric"
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      value={valueDisplay}
    />
  );
};

export default CurrencyInput;
